/**
 * API client for Fee Types endpoints
 */

import apiClient from "./client";
import type {
  FeeType,
  FeeTypeListResponse,
  CreateFeeTypeRequest,
  UpdateFeeTypeRequest,
  ListFeeTypesParams,
  FeeTypeMessageResponse,
  FeeTypeUsage,
} from "@/types/feeType";

/**
 * Fee Types API endpoints
 */
export const feeTypesApi = {
  /**
   * List fee types with pagination and filters
   */
  list: (params?: ListFeeTypesParams) =>
    apiClient.get<FeeTypeListResponse>("/api/fees/v1/", { params }),

  /**
   * Get fee type by ID
   */
  get: (id: string) =>
    apiClient.get<FeeType>(`/api/fees/v1/${id}`),

  /**
   * Create new fee type
   */
  create: (data: CreateFeeTypeRequest) =>
    apiClient.post<FeeType>("/api/fees/v1/", data),

  /**
   * Update fee type
   */
  update: (id: string, data: UpdateFeeTypeRequest) =>
    apiClient.patch<FeeType>(`/api/fees/v1/${id}`, data),

  /**
   * Delete fee type
   */
  delete: (id: string) =>
    apiClient.delete<FeeTypeMessageResponse>(`/api/fees/v1/${id}`),

  /**
   * Classes carrying this fee type and what it has billed
   */
  usage: (id: string) =>
    apiClient.get<FeeTypeUsage>(`/api/fees/v1/${id}/usage`),
};

export default feeTypesApi;
